import { z } from 'zod'

/** CIBS 查詢航班及訂票 Response Schema */
export const cibsSearchAndBookFlightResponseSchema = z.object({
  /** 轉址連結 */
  url: z.string(),
  /** 是否不符合優惠資格 */
  isPromotionIneligible: z.boolean(),
  /** 傳給1A資料 */
  postData: z.string()
})

export interface CibsSearchAndBookFlightResponse extends z.infer<
  typeof cibsSearchAndBookFlightResponseSchema
> {}
